import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import {
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Row,
} from 'reactstrap';
// Images
import redLogo from '../../images/heartbig.png';
import {
  getNewEvent,
  resetNewEvent,
} from '../../sagas/createEventSaga/reducer';
// Reducers
import { resetCe } from '../../sagas/customEventSaga/reducer';

class PromotionFeed extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      promotions: [],
    };
  }
  componentDidMount() {
    let promotions = [];
    if (this.props.alllocations !== undefined) {
      promotions = this.findPromotions(this.props.alllocations);
    }
    this.setState({ promotions: promotions, loading: false });
  }

  findPromotions(locations) {
    const promotions = [];
    if (locations.length !== undefined && locations.length > 0) {
      locations.forEach((location) => {
        let happyHours = location.happyHours;
        if (happyHours !== undefined && happyHours.length !== 0) {
          happyHours.forEach((happyHour) => {
            if (happyHour.happyHourType === 3) {
              let bundle = { happyHour, location };
              promotions.push(bundle);
            }
          });
        }
      });
    }
    return promotions;
  }

  getPromos(event) {
    let promos = [];
    // if (this.props.promos !== undefined) {
    //   this.props.promos.forEach((promo) => {
    //     if (promo.events.length !== 0) {
    //       promo.events.forEach((eventx) => {
    //         if (eventx.id === event.id) {
    //           promos.push(promo);
    //         }
    //       });
    //     }
    //   });
    // }
    if (promos.length !== 0) {
      return (
        <div>
          {/* <div>
            <img src="assets/1.jpeg" />
            <p className="legend">Legend 1</p>
          </div>
          <div>
            <img src="assets/2.jpeg" />
            <p className="legend">Legend 2</p>
          </div>
          <div>
            <img src="assets/3.jpeg" />
            <p className="legend">Legend 3</p>
          </div> */}

          {promos.map((promo, index) => (
            <div key={'key' + index}>
              <div className="promo">
                <span className="promo-reward">{promo.title}</span>
                {/* <span className="promo-criteria">{promo.criteria.text}</span> */}
              </div>
            </div>
          ))}
        </div>
      );
    }
  }

  quickEvent(event) {
    const newEvent = {
      connections: [],
      planFirst: false,
      connectFirst: false,
      clear: false,
      step: 2,
      screen: 1,
      fromVEvent: true,
      vEvent: event,
      weightedLocations: [],
    };
    this.props.getNewEvent(newEvent);
  }

  listEvents(event, index) {
    const withNoDigits = event.id.replace(/[0-9]/g, '');
    const toggler = '#' + withNoDigits;
    return (
      <Card style={{ border: '0px solid rgba(0, 0, 0, 0.125)' }}>
        <Link
          to={{
            pathname: '/vevent/' + event.id,
          }}
          className="left"
        >
          <CardImg
            top
            width="100%"
            src={event.images.heroPath}
            alt="articleHero"
          />
        </Link>
        <CardBody>
          <Container>
            <Row>
              <Col
                xs={12}
                md={12}
                sm={12}
                lg={12}
                className="no-padding"
                style={{ textAlign: 'left' }}
              >
                <span className="title">{event.title}</span>
                <span className="description">
                  {event.description}
                </span>

                <div className="clear">
                  <span className="vendorEventLocation">
                    {/* {event.locations[0].locationTitle} */}
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
          {/* <UncontrolledCollapse toggler={toggler}>
            <div className="card-section">{event.teaser}</div>
          </UncontrolledCollapse> */}
        </CardBody>
      </Card>
    );
  }

  getContent(events) {
    if (events.length !== 0) {
      return (
        <div>
          <div className="sectiontitle text-center">
            <span className="homeCat">Rewarding Experiences</span>
          </div>
          <Carousel showThumbs={false} swipeScrollTolerance={0}>
            {events.map((event, index) => (
              <div key={'key' + index}>
                {this.listEvents(event, index)}
              </div>
            ))}
          </Carousel>
        </div>
      );
    }
  }

  render() {
    if (this.state.loading) {
      return null; // or render a loading icon
    }
    if (
      this.props.promos !== undefined &&
      this.props.promos !== null &&
      this.props.promos.length !== 0
    ) {
      return (
        <div style={{ padding: '0px 0px 0px 0px' }}>
          {this.getContent(this.props.promos)}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetCe: (zone) => {
      dispatch(resetCe(zone));
    },
    getNewEvent: (newEvent) => {
      dispatch(getNewEvent(newEvent));
    },
    resetNewEvent: (newEvent) => {
      dispatch(resetNewEvent(newEvent));
    },
  };
};

function mapStateToProps(state) {
  return {
    alllocations: state.locations.locations,
    promoEvents: state.promoEvents.events,
    promos: state.promos.promos,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PromotionFeed);
